module.exports = __webpack_public_path__ + "static/scale-model-of-history-n-mystery-ghost-tours-in-lewisville-texas-0582063f4dd818d112e820effc17fc70.png";